import OrderStepComplete from "@affinity/components/OrderSteps/OrderStepComplete";
import getQuoteRevertToStep from "@affinity/Handlers/GetQuoteRevertToStep";
import { StyledFigureSteps, StyledList } from "@affinity/Pages/FunctionalComponentsPage";
import { CustomState } from "@affinity/Store/Reducers";
import translate from "@insite/client-framework/Translate";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { useSelector } from "react-redux";

const fuelNameMap = {
    1: translate("Regular"),
    2: translate("Premium"),
};

const mapStateToProps = (state: CustomState) => ({
});

const mapDispatchToProps = {
    getQuoteRevertToStep,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const StepIndicator: React.FC<Props> = ({
    getQuoteRevertToStep 
}) => {
    const { fuelName, postcode } = useSelector((state: CustomState) => ({
        fuelName: fuelNameMap[state.affinity_get_quote.selectedProduct],
        // TODO: get correct name from mappedProducts wich is currently empty?
        postcode: state.affinity_get_quote.postcode,
    }));

    const onClick = () => {
        getQuoteRevertToStep({ newStep: 1 });
    };

    return (
        <StyledFigureSteps>
            <VisuallyHidden as="figcaption">{translate("Completed steps:")}</VisuallyHidden>
            <StyledList>
                <OrderStepComplete text1={`${fuelName} fuel delivered to: `} text2={postcode} key="Fuel type: " onClick={() => onClick()}/>
            </StyledList>
        </StyledFigureSteps>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(StepIndicator);